import WithSidebar from 'Layout/WithSidebar';
import image from 'images/small-images-inside-text/Image.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import bannerImage from 'images/information-material-banner.jpg';
import { filesUniferX, filesWuxal } from './mockData';
import PDFBox from 'components/PDFBox';
import wuxalCatalog from 'images/wuxalCatalog.jpg';
import uniferCatalog from 'images/unifer-catalog.jpg';
import ProductCatalogBox from 'components/ProductCatalogBox';
import { informationMaterials } from 'components/Filter/mockData';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';

const InformationMaterials = () => {
    return (
        <>
            <Banner title="Information materials" image={bannerImage} buttonText="View catalogs" />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>agricultural solutions</LabelButton>
                        <GradientText>
                            View{' '}
                            <em>
                                our product <img src={image} alt="decor" /> catalogs
                            </em>
                            , which provide detailed information in PDF format
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                Here you will find <em>detailed descriptions of products</em>, their composition,
                                application and benefits for plants.
                            </GradientText>
                        </div>
                    </div>
                </div>

                <WithSidebar Sidebar={<Filter data={informationMaterials} />}>
                    <ProductCatalogBox
                        title="Wuxal catalog 2023"
                        image={wuxalCatalog}
                        text="Check out our Wuxal product catalog for detailed information on composition and usage."
                    />
                    <PDFBox title="Wuxal product flyers" data={filesWuxal} />
                    <ProductCatalogBox
                        title="Fertiplant - UniferX catalog 2023"
                        image={uniferCatalog}
                        text="Check out our Fertiplant - UniferX product catalog for detailed information on composition and usage."
                    />
                    <PDFBox title="UniferX+ product flyers" data={filesUniferX} />
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default InformationMaterials;
